const Logout = () => (
  <div className='container-fluid'>
    <h2>404 Not found</h2>
    <p>We couldn't find what you were looking for.</p>
  </div>
);

export default Logout;
